var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManBeard2B(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "frame_730px_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "beard_x5F_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x35__1_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#85898B",
    d: "M411.7,352.9c-1.3-8.7,0.2-13-7.1-17.4c-5.6-3.4-14.7-6.6-20.8-5.2c-2.2,0.5-7.7,4.2-11.9,5 c-7.2,1.4-16.8,1.9-26.6-1c-6.2-1.9-7-3.8-9.6-4.9c-4-1.6-9.9-0.3-13.7,0.8c-6.4,1.9-15.7,5-19.4,10.4c-4.3,6.3-3.1,19.5-3,26.6 c0.1,10-1.7,16.7,0.7,24c1.7,5,5.8,9.6,10,13.7c8.3,8.2,16.7,14.6,30,16c16.2,1.7,40.8,2.4,54.5-7.5c5.3-3.9,10.6-8.3,14.5-13.3 c5.3-6.9,4.7-11.4,5.3-19.5C415.1,372.3,413,361,411.7,352.9z M404.6,351.4c-0.3,4.8-0.3,13.1-2.3,17.5 c-2.2,4.7-5.5,10.6-10.5,13.3c-4.8,2.6-9.5,5.6-15.1,3.5c-2.3-0.9-6.3-4.1-7.2-6.1c-1.1-2.6-0.3-5.7-3.6-7.3 c-3.5-1.7-13.8-1.1-17.5,0.3c-2.3,0.9-2.6,10.4-8.4,13.2c-4.6,2.2-12.8,0.4-17-1.4c-11.1-4.9-13.6-16.6-12.5-27.1 c0.5-4.9,0.9-11,6.7-13.2c5-1.8,12.7-2.1,18.1-2.2c6.4-0.1,11.1-0.3,17.5-0.3h5.5c12.1,0,27-0.6,38.9,1 C404.1,343.4,405.1,344.4,404.6,351.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManBeard2B);
export default __webpack_public_path__ + "static/media/man_beard_2b.4c5f03f3db459e3173e9c99861991891.svg";
export { ForwardRef as ReactComponent };